<form [formGroup]="formulario" (ngSubmit)="onSubmit()" class="form-container">
  <div formArrayName="entradas">
    <div *ngFor="let entrada of entradas.controls; let i = index" [formGroupName]="i" class="entrada-card">
      <mat-card>
        <mat-card-header>
          <mat-card-title>
            <!-- Entrada para fotos con el club -->
            Entrada para Foto 11 Inicial
            <!-- <ng-container *ngIf="!entrada.get('menor.check_abonado')?.value; else abonado">
              ({{ ticketPrice | number:'1.2-2' }} €)
            </ng-container> -->
            <ng-template #abonado>
              (<span class="precio-tachado">{{ ticketPrice | number:'1.2-2' }} €</span>
              <span class="precio-abonado"> {{getPrecioAbonado(i)}} €</span>)
            </ng-template>
          </mat-card-title>
        </mat-card-header>

        <mat-card-content>
          <!-- RESPONSABLE -->
          <div formGroupName="responsable" class="seccion">
            <h3 class="seccion-titulo"><mat-icon>person_outline</mat-icon>&nbsp;Responsable</h3>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label><mat-icon>person</mat-icon>&nbsp;Nombre</mat-label>
                <input matInput placeholder="Nombre del responsable" formControlName="nombre" required>
                <mat-error *ngIf="entrada.get(['responsable', 'nombre'])?.hasError('required')">
                  El nombre es obligatorio
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" class="form-field">
                <mat-label><mat-icon>badge</mat-icon>&nbsp;Apellidos</mat-label>
                <input matInput placeholder="Apellidos del responsable" formControlName="apellidos" required>
                <mat-error *ngIf="entrada.get(['responsable', 'apellidos'])?.hasError('required')">
                  Los apellidos son obligatorios
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" class="form-field">
                <mat-label><mat-icon>fingerprint</mat-icon>&nbsp;DNI</mat-label>
                <input matInput placeholder="Documento de identidad" formControlName="dni" required>
                <mat-error *ngIf="entrada.get(['responsable', 'dni'])?.hasError('required')">
                  El DNI es obligatorio
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" class="form-field">
                <mat-label><mat-icon>email</mat-icon>&nbsp;Email</mat-label>
                <input matInput type="email" placeholder="correo@ejemplo.com" formControlName="email" required>
                <mat-error *ngIf="entrada.get(['responsable', 'email'])?.hasError('required')">
                  El email es obligatorio
                </mat-error>
                <mat-error *ngIf="entrada.get(['responsable', 'email'])?.hasError('email')">
                  Introduce un email válido
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" class="form-field">
                <mat-label><mat-icon>phone</mat-icon>&nbsp;Teléfono</mat-label>
                <input matInput type="tel" placeholder="Ej: 600 123 456" formControlName="telefono" required>
                <mat-error *ngIf="entrada.get('responsable.telefono')?.hasError('required')">
                  El teléfono es obligatorio
                </mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" class="form-field">
                <mat-label><mat-icon>home</mat-icon>&nbsp;Domicilio</mat-label>
                <input matInput placeholder="Calle, número, piso..." formControlName="domicilio" autocomplete="off" required>
                <mat-error *ngIf="entradas.at(i).get('responsable.domicilio')?.hasError('required')">
                  El domicilio es obligatorio
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" class="form-field">
                <mat-label><mat-icon>markunread_mailbox</mat-icon>&nbsp;Código Postal</mat-label>
                <input matInput placeholder="Ej: 41001" formControlName="codigoPostal" autocomplete="off" required>
                <mat-error *ngIf="entradas.at(i).get('responsable.codigoPostal')?.hasError('required')">
                  El código postal es obligatorio
                </mat-error>
                <mat-error *ngIf="entradas.at(i).get('responsable.codigoPostal')?.hasError('codigoPostal')">
                  Introduce un código postal válido
                </mat-error>
              </mat-form-field>
            </div>

            <div *ngIf="i > 0" class="copy-btn mt-3">
              <button mat-stroked-button color="primary" type="button" (click)="copiarResponsableAnterior(i)">
                <mat-icon>content_copy</mat-icon>&nbsp;Copiar responsable anterior
              </button>
            </div>

            <div *ngIf="i === 0" class="copy-btn mt-3 flex gap-2 flex-wrap">
              <button mat-stroked-button color="primary" type="button" (click)="copiarCompradorComoResponsable(0)">
                <mat-icon>content_copy</mat-icon>&nbsp;Copiar comprador como responsable
              </button>

              <button mat-stroked-button color="accent" type="button" (click)="copiarCompradorComoResponsableEnTodos()">
                <mat-icon>group_add</mat-icon>&nbsp;Copiar comprador como responsable en todos
              </button>
            </div>
          </div>

          <mat-divider class="my-4"></mat-divider>

          <!-- MENOR -->
          <div formGroupName="menor" class="seccion">
            <h3 class="seccion-titulo"><mat-icon>person_outline</mat-icon>&nbsp;Menor</h3>

            <div style="margin-bottom: 20px">
              <mat-slide-toggle
                formControlName="toggle_palmerin"
                (change)="onTogglePalmerinChange(i, $event.checked)">¿Es socio?</mat-slide-toggle>
            </div>

            <div class="id-abonado-container" *ngIf="getIsPalmerin(i)">
              <!-- ID abonado -->
              <mat-form-field appearance="outline" class="flex-grow-1 flex-basis-0">
                <mat-label>ID Abonado</mat-label>
                <input matInput formControlName="id_abonado">
                <mat-error *ngIf="entrada.get(['menor','id_abonado'])?.hasError('required')">
                  El ID de abonado es obligatorio
                </mat-error>
                <mat-error *ngIf="entrada.get(['menor','id_abonado'])?.hasError('noEncontrado')">
                  No se ha encontrado un abonado válido, revisa ID y PIN
                </mat-error>
                <mat-error *ngIf="entrada.get(['menor','id_abonado'])?.hasError('duplicado')">
                  ID repetido en otra entrada
                </mat-error>
                <!-- Mensaje de éxito -->
                <mat-hint *ngIf="entrada.get(['menor', 'check_abonado'])?.value" class="mensaje-exito">
                  Abonado encontrado, rellenando información automáticamente
                </mat-hint>
              </mat-form-field>

              <!-- PIN abonado -->
              <mat-form-field appearance="outline" class="pin-input">
                <mat-label>PIN Abonado</mat-label>
                <input matInput formControlName="pin_abonado">
                <mat-error *ngIf="entrada.get(['menor','pin_abonado'])?.hasError('required')">
                  El PIN es obligatorio
                </mat-error>
                <mat-error *ngIf="entrada.get(['menor','pin_abonado'])?.hasError('noEncontrado')"></mat-error>
                <mat-error *ngIf="entrada.get(['menor','pin_abonado'])?.hasError('duplicado')">
                  PIN repetido en otra entrada
                </mat-error>
              </mat-form-field>

              <!-- Botón -->
              <button mat-icon-button color="primary" matTooltip="Buscar Abonado" type="button"
                (click)="comprobarIdAbonado(i)" [disabled]="
                  !entrada.get(['menor','id_abonado'])?.value ||
                  !entrada.get(['menor','pin_abonado'])?.value
                ">
                <mat-icon>search</mat-icon>
              </button>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-2">
              <mat-form-field [class.readonly]="getIsPalmerin(i)" appearance="outline">
                <mat-label><mat-icon>person</mat-icon>&nbsp;Nombre</mat-label>
                <input matInput [readonly]="getIsPalmerin(i)" formControlName="nombre">
              </mat-form-field>

              <mat-form-field [class.readonly]="getIsPalmerin(i)" appearance="outline">
                <mat-label><mat-icon>badge</mat-icon>&nbsp;Apellidos</mat-label>
                <input matInput [readonly]="getIsPalmerin(i)" formControlName="apellidos">
              </mat-form-field>

              <mat-form-field [class.readonly]="getIsPalmerin(i)" [class.campo-edad-invalida]="isFechaNacimientoInvalid(i)" appearance="outline">
                <mat-label>Fecha de nacimiento</mat-label>
                <input
                  matInput
                  [matDatepicker]="pickerFechaNacimiento"
                  [value]="getFechaNacimientoDate(i)"
                  [disabled]="getIsPalmerin(i)"
                  (click)="pickerFechaNacimiento.open()"
                  (dateChange)="onFechaNacimientoChange(i, $event)">
                <mat-datepicker-toggle matSuffix [for]="pickerFechaNacimiento"></mat-datepicker-toggle>
                <mat-datepicker #pickerFechaNacimiento></mat-datepicker>
                <mat-hint [style.font-weight]="isFechaNacimientoInvalid(i) ? 'bold' : 'normal'">
                  Solo podrán participar menores de hasta 13 años el día del partido.
                </mat-hint>
                <mat-error *ngIf="entrada.get(['menor','fecha_nacimiento'])?.hasError('edadNoValida')">
                  El menor debe tener entre 0 y 13 años el día del partido
                </mat-error>
              </mat-form-field>

            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

</form>
